import { Action } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { isType } from "typescript-fsa";
import { isDateTimeAfter, isDateTimeBefore } from "../../utils/date";
import { campaignActions } from "./actions";
import { Campaign, CampaignState } from "./types";

const initialState: CampaignState = {
  activeCampaigns: [], // 変更：空配列で初期化
  selectionMade: false,
};

export function CampaignReducer(
  state = initialState,
  action: Action,
): CampaignState {
  if (isType(action, campaignActions.fetchActiveCampaign.started)) {
    return {
      ...state,
    };
  }

  if (isType(action, campaignActions.fetchActiveCampaign.done)) {
    const campaigns = action.payload.result.campaigns || [];
    const later90DaysFromNow = dayjs().add(90, "day");

    // 各キャンペーンを変換
    const activeCampaigns = campaigns.map((campaign): Campaign => {
      const campaignSaleEndDate = dayjs(campaign.sale_end_date);
      const base = {
        id: campaign.id,
        name: campaign.name,
        description: campaign.description ?? "",
        image: campaign.image,
        startDate: new Date(campaign.start_date),
        endDate: new Date(campaign.end_date),
        saleStartDate: new Date(campaign.sale_start_date),
        saleEndDate: new Date(campaign.sale_end_date),
        minSaleStartDate:
          isDateTimeAfter(new Date(), new Date(campaign.end_date)) ||
          isDateTimeBefore(new Date(), new Date(campaign.sale_start_date))
            ? new Date(campaign.sale_start_date)
            : new Date(),
        maxSaleEndDate: campaignSaleEndDate.isBefore(later90DaysFromNow)
          ? campaignSaleEndDate.toDate()
          : later90DaysFromNow.toDate(),
        storeIds: campaign.store_ids,
        sortOrder: campaign.sort_order,
      };
      if (campaign.type === 0) {
        return {
          ...base,
          type: "regular",
        };
      } else if (campaign.type === 1) {
        return {
          ...base,
          type: "early_bird",
          discountSettingId: campaign.discount_setting_id,
        };
      }
      return {
        ...base,
        type: "stock_item",
        limitedStockSettingId: campaign.limited_stock_setting_id,
        isSoldOut: campaign.is_sold_out,
      };
    });

    return {
      ...state,
      activeCampaigns,
      selectionMade: false,
    };
  }

  if (isType(action, campaignActions.markSelectionMade)) {
    return {
      ...state,
      selectionMade: true,
    };
  }

  if (isType(action, campaignActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
